import type {
  ChainModifiers,
  Entry,
  EntryFieldTypes,
  EntrySkeletonType,
  LocaleCode,
} from "contentful";

import type { TypeImageWithCtaSkeleton } from "./TypeImageWithCta";
import type { TypeImageWithHyperlinkSkeleton } from "./TypeImageWithHyperlink";
import type { TypeLinkSkeleton } from "./TypeLink";

export interface TypeTilesFields {
  name: EntryFieldTypes.Symbol;
  title?: EntryFieldTypes.Symbol;
  link?: EntryFieldTypes.EntryLink<TypeLinkSkeleton>;
  content: EntryFieldTypes.Array<
    EntryFieldTypes.EntryLink<
      TypeImageWithCtaSkeleton | TypeImageWithHyperlinkSkeleton
    >
  >;
  numberOfColumnsDesktop: EntryFieldTypes.Integer<2 | 3 | 4 | 6>;
  numberOfColumnsTablet: EntryFieldTypes.Integer<2 | 3 | 4>;
  numberOfColumnsMobile: EntryFieldTypes.Integer<1 | 2>;
  maxWidth?: EntryFieldTypes.Integer<1280 | 1920 | 2560 | 768>;
}

export type TypeTilesSkeleton = EntrySkeletonType<TypeTilesFields, "tiles">;
export type TypeTiles<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeTilesSkeleton, Modifiers, Locales>;

export function isTypeTiles<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeTiles<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === "tiles";
}
